export function slice(input, start = undefined, end = undefined) {
  return input.slice(start, end);
}
